import { render, staticRenderFns } from "./ButtonForm.vue?vue&type=template&id=04d79727"
import script from "./ButtonForm.vue?vue&type=script&lang=js"
export * from "./ButtonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports